import { render, staticRenderFns } from "./IdentityProviders.vue?vue&type=template&id=2c41b7f0&scoped=true&"
import script from "./IdentityProviders.vue?vue&type=script&lang=ts&"
export * from "./IdentityProviders.vue?vue&type=script&lang=ts&"
import style0 from "./IdentityProviders.vue?vue&type=style&index=0&id=2c41b7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41b7f0",
  null
  
)

export default component.exports